import { defineStore } from "pinia";
import { ref } from "vue";

interface ConfirmModalArgs {
  title?: string;
  text?: string;
  /** Makes the modal too look similar to native system. At least on IOS systems. */
  isNative?: boolean;
}

interface ConfirmModalActions {
  isOpen: boolean;
  confirm?: () => any;
  reject?: () => any;
}

export const useModals = defineStore("modals", () => {
  const confirmModalData = ref<ConfirmModalArgs & ConfirmModalActions>({
    isOpen: false,
  });

  function openConfirmModal(args: ConfirmModalArgs) {
    return new Promise((resolve) => {
      const closeModal = (state: boolean) => {
        confirmModalData.value = {
          title: undefined,
          text: undefined,
          isOpen: false,
          isNative: false,
        };
        resolve(state);
      };

      confirmModalData.value = {
        ...args,
        isOpen: true,
        confirm: () => closeModal(true),
        reject: () => closeModal(false),
      };
    });
  }

  return {
    openConfirmModal,
    confirmModalData,
  };
});
